import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes: SearchkitWrapperProps['searchSettings']['search_attributes'] = [
  // Node title.
  {
    field: 'title',
    weight: 5,
  },
  // Taxonomy name.
  {
    field: 'name',
    weight: 5,
  },
  // Document title
  {
    field: 'filename',
    weight: 4,
  },
  // Contents
  {
    field: 'body',
    weight: 3,
  },
  {
    field: 'attachments_extracted_file',
    weight: 2,
  },
  {
    field: 'description',
    weight: 3,
  },
  {
    field: 'subject',
    weight: 2,
  },
  {
    field: 'theme',
    weight: 2,
  },
  // Sub contents.
  {
    field: 'paragraph_title',
    weight: 3,
  },
  {
    field: 'paragraph_body',
    weight: 2,
  },
];

export const highlightAttributes: SearchkitWrapperProps['searchSettings']['highlight_attributes'] = [
  'body',
  'description',
  'document_title',
  'filename',
  'name',
  'title',
];

export const resultAttributes: SearchkitWrapperProps['searchSettings']['result_attributes'] = [
  'url',
  // Node title
  'title',
  // Taxonomy
  'name',
  'activity_name',
  // Media -> Documents
  'filename',
  'document_title',
  'document_url',
  // Contents
  'body',
  'description',
  'paragraph_video_url',
  // General
  'combined_created',
  'combined_types',
  'combined_domain_access',
  // Image styles
  'node_media_item_ratio_4_3_sm',
  'node_image_ratio_4_3_sm',
  'term_image_ratio_4_3_sm',
  'vacancy_type',
  'theme',
];

export const facetAttributes: SearchkitWrapperProps['searchSettings']['facet_attributes'] = [
  {
    attribute: 'combined_types',
    field: 'combined_types',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
        exclude: ['overview_page'],
      },
    }),
  },
  {
    attribute: 'entity_type',
    field: 'entity_type',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
];

export const sorting: SearchkitWrapperProps['searchSettings']['sorting'] = {
  default: {
    field: '_score',
    order: 'desc',
  },
  _created: {
    field: 'combined_created',
    order: 'desc',
  },
};
